import { getField, updateField } from 'vuex-map-fields'
import getAssignmentFiltersModel from './models/assignmentFilters'

const assignmentFilters = {
  namespaced: true,
  state: {
    ...getAssignmentFiltersModel()
  },
  getters: {
    getField,
    getSearchObject: (state) => {
      return state
    }
  },
  mutations: {
    updateField,
    clearFilters: (state) => {
      state.userId = null
      state.clientId = null
      state.jobTitle = null
      state.active = null
      state.includeInactive = null
      state.overtimeEligible = null
    }
  },
  actions: {
    clearFilters: ({ commit }) => {
      return commit('clearFilters')
    }
  }
}

export default assignmentFilters
